import { API_BASE } from "./apiBase";
import { getApiErrorMessage } from "./errorMessages";
import { stringifySnake } from "./serialization";

const TOKEN_KEY = "cerebro_jwt";

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY);
}

export function setToken(jwt) {
  if (!jwt) return;
  window.localStorage.setItem(TOKEN_KEY, jwt);
}

export function clearToken() {
  window.localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export async function login(username, password) {
  const response = await fetch(`${API_BASE}/api/v1/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: stringifySnake({ username, password }),
  });

  if (!response.ok) {
    const message = await safeErrorMessage(response);
    throw new Error(message || "Credenciales inválidas.");
  }

  const data = await response.json();
  if (!data?.jwt) {
    throw new Error("Respuesta inválida del servidor.");
  }
  setToken(data.jwt);
  return data.jwt;
}

export async function loginWithGoogle(credential) {
  const response = await fetch(`${API_BASE}/api/v1/login/google`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: stringifySnake({ credential }),
  });

  if (!response.ok) {
    const message = await safeErrorMessage(response);
    throw new Error(message || "No se pudo iniciar sesión con Google.");
  }

  const data = await response.json();
  if (!data?.jwt) {
    throw new Error("Respuesta inválida del servidor.");
  }
  setToken(data.jwt);
  return data.jwt;
}

export async function refreshSession() {
  const response = await fetch(`${API_BASE}/api/v1/login/refresh`, {
    method: "POST",
    credentials: "include",
  });

  if (!response.ok) {
    clearToken();
    return null;
  }

  const data = await response.json();
  if (!data?.jwt) {
    clearToken();
    return null;
  }
  setToken(data.jwt);
  return data.jwt;
}

export async function logout() {
  try {
    await fetch(`${API_BASE}/api/v1/login/logout`, { method: "POST", credentials: "include" });
  } finally {
    clearToken();
  }
}

async function safeErrorMessage(response) {
  try {
    const data = await response.json();
    return getApiErrorMessage(data, response.status);
  } catch (_) {
    return null;
  }
}
